import React from 'react'
import PropTypes from 'prop-types'
import {
    Box,
    Text,
    Divider,
    useMultiStyleConfig
} from '@salesforce/retail-react-app/app/components/shared/ui'

/* Icons */
import { AccordionArrow } from '../../../icons/index'

/* Utils */
import { renderComponentsSwitch } from '../../utils/contentRenderer'
import { generateStyles } from '../../utils/utils'

const WebFooterTopBarColumnBlock = ({
    TitleDescription,
    showDivider,
    SplitBarColor
}) => {
    const styles = useMultiStyleConfig('WebFooterTopBarColumnBlock', {
        SplitBarColor: SplitBarColor
    })

    return (
        <React.Fragment>
            <Box {...styles.container}>
                <Box {...styles.hideOnDesktop} {...styles.titleContainer}>
                    {renderComponentsSwitch(TitleDescription?.Cta?.Expanded, {
                        ContainerCustomStyling: { width: '100%' },
                        stylingTextOverwrite: { ...styles.title },
                        OverwriteCtaLinkText: TitleDescription?.Title
                    })}
                    <AccordionArrow {...styles.arrow} />
                </Box>

                {TitleDescription?.Title !== '' &&
                    <Text
                        {...styles.titleContainer} {...styles.hideOnMobile}
                        {...generateStyles(TitleDescription?.WebFooterTopBarColumnBlockTitleStyle, { ...styles.title })}>
                        {TitleDescription?.Title}
                    </Text>
                }

                {TitleDescription?.Description !== '' &&
                    <Text
                        {...styles.description}
                        {...generateStyles(TitleDescription?.WebFooterTopBarColumnBlockDescriptionStyle, { ...styles.description })}>
                        {TitleDescription?.Description}
                    </Text>
                }

                <Box {...styles.linkContainer}>
                    {renderComponentsSwitch(
                        TitleDescription?.Cta?.Expanded,
                        {
                            stylingTextOverwrite: { ...styles.link },
                            ContainerCustomStyling: { width: '100%' }
                        }
                    )}
                </Box>
            </Box>

            {showDivider &&
                <Box>
                    <Divider orientation='vertical' data-testid='features-links-divider' {...styles.dividerStyling} />
                </Box>
            }
        </React.Fragment>
    )
}

WebFooterTopBarColumnBlock.propTypes = {
    TitleDescription: PropTypes.object,
    showDivider: PropTypes.bool,
    SplitBarColor: PropTypes.string
}

export default WebFooterTopBarColumnBlock
